import http from './http'

export default {
    developments() {
        return http.get('sadasi/developments')
            .then(({ data }) => data)
    }
}